import $ from 'jquery';
import 'slick-carousel';


$('.news-slider').each((i, el) => {
    const $root = $(el);
    const $slider = $root.find('.news-slider__slider');
    const $arrows = $root.find('.news-slider__arrows');

    $slider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        rows: 0,
        prevArrow: $arrows.find('.slick-prev'),
        nextArrow: $arrows.find('.slick-next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

});
